/**
 * Focus helpers — put the caret inside a block's editable area.
 * Retries a few times because newly created/converted blocks may not have
 * rendered yet (especially nested ones inside callouts/rows).
 *
 * Options: { atStart: true } → caret at the beginning;
 *          { offset: n }     → caret after the n-th character (merge point);
 *          default           → caret at the end.
 */

const placeCaretAtOffset = (el, offset) => {
  const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
  let remaining = offset;
  let node = walker.nextNode();
  while (node) {
    if (remaining <= node.textContent.length) {
      const range = document.createRange();
      range.setStart(node, remaining);
      range.collapse(true);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      return true;
    }
    remaining -= node.textContent.length;
    node = walker.nextNode();
  }
  return false;
};

/** Focus the search field on a newly inserted linked-variable-row picker. */
export const focusLinkedVariableRowPicker = (blockId, attempt = 0) => {
  setTimeout(() => {
    const el = document.querySelector(
      `[data-block-id="${blockId}"] .linked-variable-row-picker__search`
    );
    if (!el) {
      if (attempt < 8) focusLinkedVariableRowPicker(blockId, attempt + 1);
      return;
    }
    el.focus({ preventScroll: true });
  }, attempt === 0 ? 0 : 20);
};

export const focusEditable = (
  blockId,
  { atStart = false, offset = null, preventScroll = false } = {},
  attempt = 0
) => {
  setTimeout(() => {
    const el = document.querySelector(`[data-block-id="${blockId}"] .doc-editable`);
    if (!el) {
      if (attempt < 5) focusEditable(blockId, { atStart, offset, preventScroll }, attempt + 1);
      return;
    }
    el.focus({ preventScroll });
    const place = () => {
      if (offset !== null && placeCaretAtOffset(el, offset)) return;
      const range = document.createRange();
      range.selectNodeContents(el);
      range.collapse(atStart);
      const selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
    };
    place();
    // Re-assert once: react-contenteditable may swap innerHTML / restyle
    // right after (merge, outdent) and replaceCaret() parks at the end.
    if (attempt === 0 && (offset !== null || atStart)) {
      setTimeout(() => {
        const el2 = document.querySelector(`[data-block-id="${blockId}"] .doc-editable`);
        if (el2 && document.activeElement === el2) {
          if (offset !== null) {
            if (!placeCaretAtOffset(el2, offset)) place();
          } else {
            place();
          }
        }
      }, 45);
    }
  }, attempt === 0 ? 0 : 20);
};
